function clickPodiumBubbleButton() {
  const bubbleFrame = document.getElementById('podium-bubble');
  if (!bubbleFrame) return false;

  let frameDoc = null;
  try {
    // contentWindow.document throws on cross-origin frames (typical on iOS).
    frameDoc = bubbleFrame.contentDocument;
  } catch (error) {
    frameDoc = null;
  }

  const chatButton = frameDoc && frameDoc.getElementById('podium-website-widget-button');
  if (!chatButton) return false;

  chatButton.click();
  return true;
}

function openPodiumChatWidget() {
  try {
    if (window.PodiumWebChat && typeof window.PodiumWebChat.open === 'function') {
      window.PodiumWebChat.open();
      return;
    }
    if (window.PodiumLivechat && typeof window.PodiumLivechat.open === 'function') {
      window.PodiumLivechat.open();
      return;
    }
  } catch (error) {
    // Fall through to the bubble button if the public API is not ready.
  }

  if (clickPodiumBubbleButton()) return;

  const startedAt = Date.now();
  const retry = window.setInterval(() => {
    try {
      if (window.PodiumWebChat && typeof window.PodiumWebChat.open === 'function') {
        window.clearInterval(retry);
        window.PodiumWebChat.open();
        return;
      }
    } catch (error) {
      // Keep retrying until timeout.
    }

    if (clickPodiumBubbleButton() || Date.now() - startedAt > 4000) {
      window.clearInterval(retry);
    }
  }, 100);
}

if (!openPodiumChatWidget.bound) {
  openPodiumChatWidget.bound = true;
  document.addEventListener('click', (event) => {
    if (!event.target.closest('.js-inventory-chat-cta')) return;
    event.preventDefault();
    openPodiumChatWidget();
  });
}

if (!customElements.get('product-inventory')) {
  class ProductInventory extends HTMLElement {
    constructor() {
      super();
      if (this.hidden) {
        this.initLazySection();
      } else {
        window.initLazyScript(this, this.initLazySection.bind(this));
      }
    }

    initLazySection() {
      this.inventoryNotice = this.querySelector('.js-inventory-notice');
      this.urgencyMessage = this.querySelector('.js-inventory-urgency');
      this.indicatorBar = this.querySelector('.js-inventory-indicator');
      this.variantInventory = this.getVariantInventory();

      this.chatCta = this.querySelector('.js-inventory-chat-cta');

      // Bind to on:variant:change event for this product
      const variantPicker = this.closest('.product-info').querySelector('variant-picker');
      if (variantPicker) {
        variantPicker.addEventListener('on:variant:change', this.handleVariantChange.bind(this));
      }

      // Init
      this.updateInventory(
        parseInt(this.dataset.inventoryQuantity, 10),
        this.dataset.variantAvailable === 'true',
        this.dataset.inventoryPolicy
      );
    }

    /**
     * Gets the inventory data for all product variants
     * @returns {?object}
     */
    getVariantInventory() {
      const dataEl = this.querySelector('[type="application/json"]');
      return this.variantInventory || JSON.parse(dataEl.textContent);
    }

    /**
     * Handles a 'change' event on the variant picker element
     * @param {object} evt - Event object
     */
    handleVariantChange(evt) {
      if (evt.detail.variant) {
        const inventory = this.variantInventory.filter(
          (variant) => variant.id === evt.detail.variant.id
        )[0];
        this.updateInventory(
          inventory.inventory_quantity,
          inventory.available,
          inventory.inventory_policy
        );
      } else {
        this.updateInventory(0, false);
        this.hidden = true;
      }
    }

    /**
     * @param {string} inventoryLevel
     */
    updateInventoryIcon(inventoryLevel) {
      const textWrapper = this.querySelector('.product-inventory__text');
      if (!textWrapper) return;

      const checkIcon = '<svg xmlns="http://www.w3.org/2000/svg" width="20" height="21" viewBox="0 0 20 21" fill="none" aria-hidden="true"><circle cx="9.5" cy="10.4475" r="7.5" fill="currentColor" stroke="currentColor" stroke-width="1.66667" stroke-linejoin="round"/><path d="M7.08325 10.7808L9.16659 13.0308L12.9166 8.86414" stroke="white" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round"/></svg>';
      const outOfStockIcon = '<svg xmlns="http://www.w3.org/2000/svg" width="20" height="21" viewBox="0 0 20 21" fill="none" aria-hidden="true"><circle cx="10" cy="10.9475" r="7.5" fill="currentColor" stroke="currentColor" stroke-width="1.66667" stroke-linejoin="round"/><path d="M10 11.7809V6.78088" stroke="white" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round"/><circle cx="1.04167" cy="1.04167" r="1.04167" transform="matrix(1 0 0 -1 8.95825 15.5309)" fill="white"/></svg>';

      let icon = textWrapper.querySelector('.product-inventory__icon');

      if (inventoryLevel === 'none') {
        if (!icon) {
          icon = document.createElement('span');
          textWrapper.insertBefore(icon, this.inventoryNotice || textWrapper.firstChild);
        }
        icon.className = 'product-inventory__icon out-of-stock';
        icon.innerHTML = outOfStockIcon;
        icon.hidden = false;
      } else if (inventoryLevel === 'backordered') {
        if (!icon) {
          icon = document.createElement('span');
          textWrapper.insertBefore(icon, this.inventoryNotice || textWrapper.firstChild);
        }
        icon.className = 'product-inventory__icon available-to-order';
        icon.innerHTML = checkIcon;
        icon.hidden = false;
      } else if (['in_stock', 'normal'].includes(inventoryLevel)) {
        if (!icon) {
          icon = document.createElement('span');
          textWrapper.insertBefore(icon, this.inventoryNotice || textWrapper.firstChild);
        }
        icon.className = 'product-inventory__icon in-stock';
        icon.innerHTML = checkIcon;
        icon.hidden = false;
      } else if (icon) {
        icon.hidden = true;
      }
    }

    /**
     *
     * Updates the inventory notice
     * @param {number} count - the inventory quantity available
     * @param {boolean} available - whether current variant is available
     * @param {string} inventoryPolicy - whether product continues selling when out of stock
     */
    updateInventory(count, available, inventoryPolicy) {
      const rdcQuantity = parseInt(this.dataset.rdcQuantity, 10) || 0;
      const hasRdcStock = rdcQuantity > 0;

      if (count === 0 && !available && !hasRdcStock && this.hidden) {
        return;
      }

      let inventoryLevel;
      const displayText = (this.dataset.displayText || '').trim();
      const etaMessage = (this.dataset.etaMessage || '').trim();
      let stockTitleFromMetafield = '';
      if (displayText || etaMessage) {
        stockTitleFromMetafield = (window.theme && typeof theme.getStockTitleKey === 'function')
          ? theme.getStockTitleKey(displayText, null, etaMessage)
          : (function (text, eta) {
              const value = String(text).trim().toLowerCase();
              const etaText = String(eta || '').trim().toLowerCase();
              if (value.includes('in stock shortly')) return 'in_stock_shortly';
              if (value.includes('discontinued') || etaText.includes('discontinued')) return 'discontinued';
              if (value.includes('not available')) return 'not_available';
              if (value.includes('out of stock') || value === 'sold out') return 'out_of_stock';
              if (value.includes('available to order')) return 'available_to_order';
              if (value.includes('in stock')) return 'in_stock';
              return '';
            })(displayText, etaMessage);
      }

      if (stockTitleFromMetafield && window.theme && typeof theme.getInventoryLevelFromStockTitle === 'function') {
        inventoryLevel = theme.getInventoryLevelFromStockTitle(stockTitleFromMetafield, true);
      } else if (stockTitleFromMetafield === 'out_of_stock' || stockTitleFromMetafield === 'not_available' || stockTitleFromMetafield === 'discontinued') {
        inventoryLevel = 'none';
      } else if (stockTitleFromMetafield === 'available_to_order' || stockTitleFromMetafield === 'in_stock_shortly') {
        inventoryLevel = 'backordered';
      } else if (stockTitleFromMetafield === 'in_stock') {
        inventoryLevel = 'normal';
      } else if (count <= 0) {
        if (hasRdcStock || inventoryPolicy === 'continue') {
          inventoryLevel = 'backordered';
        } else if (available) {
          inventoryLevel = 'in_stock';
        } else {
          inventoryLevel = 'none';
        }
      } else {
        inventoryLevel = 'normal';
      }

      if (!(inventoryLevel === 'backordered' && this.dataset.showNoStockBackordered === 'false')) {
        this.hidden = false;

        // Set the inventory level data attribute
        this.setAttribute('data-inventory-level', inventoryLevel);

        if (this.inventoryNotice) {
          this.inventoryNotice.classList.toggle('product-on-backorder-msg', inventoryLevel === 'backordered');
        }

        this.updateInventoryIcon(inventoryLevel);

        // Merchant-supplied display text always wins; otherwise fall back to a simple status string
        if (this.inventoryNotice) {
          if (this.dataset.displayText) {
            this.inventoryNotice.innerText = this.dataset.displayText;
          } else if (inventoryLevel === 'backordered') {
            this.inventoryNotice.innerText = theme.strings.backordered;
          } else if (inventoryLevel === 'none') {
            this.inventoryNotice.innerText = theme.strings.noStock;
          } else {
            this.inventoryNotice.innerText = theme.strings.inStock;
          }
        }

        const noticeText = (this.inventoryNotice && this.inventoryNotice.innerText) || this.dataset.displayText || '';
        const stockTitleKey = (window.theme && typeof theme.getStockTitleKey === 'function')
          ? theme.getStockTitleKey(noticeText, inventoryLevel, etaMessage)
          : stockTitleFromMetafield || (inventoryLevel === 'backordered'
            ? 'available_to_order'
            : (inventoryLevel === 'none' ? 'out_of_stock' : 'in_stock'));
        this.setAttribute('data-stock-title', stockTitleKey);

        if (this.chatCta) {
          this.chatCta.hidden = this.dataset.messageUsForEta !== 'true';
        }

        // Update the bar indicator
        if (this.indicatorBar) {
          this.indicatorBar.hidden = false;

          let newWidth;
          if ((count >= this.dataset.scale || inventoryLevel === 'in_stock') && inventoryLevel !== 'backordered') {
            newWidth = 100;
          } else {
            newWidth = ((100 / parseInt(this.dataset.scale, 10)) * count).toFixed(1);
          }
          this.indicatorBar.querySelector('span').style.width = `${newWidth}%`;
        }
      } else {
        this.hidden = true;
        if (this.chatCta) this.chatCta.hidden = true;
      }
    }
  }

  customElements.define('product-inventory', ProductInventory);
}
